"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValidSession = exports.removeSession = exports.setSession = void 0;
const storage_1 = require("../../build-babel/token/storage");
const cookie_1 = require("../../build-babel/token/cookie");
const redirect_1 = require("../../build-babel/redirect");
const token_1 = require("../../build-babel/token");
const setSession = (token, baseUrl) => {
  (0, storage_1.setToken)(token);
  (0, cookie_1.setCookie)(token, baseUrl);
};
exports.setSession = setSession;
const removeSession = (baseUrl, isRemoveRedirectUrl = true) => {
  (0, storage_1.removeToken)();
  (0, cookie_1.removeCookie)(baseUrl);
  isRemoveRedirectUrl && (0, redirect_1.removeRedirectUrl)();
};
exports.removeSession = removeSession;
const hasValidSession = baseUrl => {
  if (!(0, cookie_1.hasCookie)(baseUrl)) return false;
  if ((0, storage_1.hasToken)()) {
    const token = (0, storage_1.getToken)();
    return (0, token_1.hasValidToken)(token);
  }
  return false;
};
exports.hasValidSession = hasValidSession;
//# sourceMappingURL=index.js.map